import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  width: 460px;

  /* Token Section */
  .token-section {
    background: ${(props) =>
      props.theme.mode === "dark" ? "#1e1e1e" : "#fff"};
    border: 1px solid
      ${(props) => (props.theme.mode === "dark" ? "#444" : "#e0e0e0")};
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;

    h4 {
      margin: 0 0 8px 0;
      font-size: 13px;
      font-weight: 600;
      color: ${(props) => (props.theme.mode === "dark" ? "#1877f2" : "#1877f2")};
    }

    .token-container {
      background: ${(props) =>
        props.theme.mode === "dark" ? "#2a2a2a" : "#f5f5f5"};
      border: 1px solid
        ${(props) => (props.theme.mode === "dark" ? "#444" : "#ddd")};
      border-radius: 6px;
      padding: 10px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: ${(props) =>
          props.theme.mode === "dark" ? "#333" : "#ebebeb"};
      }

      .token-with-copy {
        display: flex;
        align-items: center;
        gap: 8px;

        .copy-icon {
          color: #1877f2;
          min-width: 14px;
          transition: all 0.2s;

          &.copied {
            color: #42b72a;
          }
        }

        .token-text {
          font-family: "Courier New", monospace;
          font-size: 12px;
          color: ${(props) => (props.theme.mode === "dark" ? "#e4e4e4" : "#333")};
          word-break: break-all;
        }
      }
    }

    .token-hint {
      margin: 6px 0 0 0;
      font-size: 11px;
      color: ${(props) => (props.theme.mode === "dark" ? "#999" : "#666")};
      font-style: italic;
    }
  }

  /* Connection Section */
  .connection-section {
    margin-bottom: 16px;
  }

  .connection-section h4 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .connections-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .connection-item {
    padding: 10px 12px;
    border: 2px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .connection-item:hover {
    border-color: #4086f4;
    background: #f0f7ff;
  }

  .connection-item.active {
    border-color: #4086f4;
    background: #e6f2ff;
  }

  .connection-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .check-icon {
    color: #4086f4;
    font-size: 14px;
  }

  .loading-text {
    padding: 12px;
    text-align: center;
    color: #666;
    font-size: 13px;
  }

  .no-connections {
    padding: 16px;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 6px;
    text-align: center;
  }

  .no-connections p {
    margin: 0 0 8px 0;
    color: #856404;
    font-size: 13px;
  }

  /* Platform Section */
  .platform-section {
    margin-bottom: 16px;
  }

  .platform-section h4 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .platform-toggles {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .platform-toggles.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  /* Webhook Section */
  .webhook-section {
    margin-bottom: 15px;
  }

  .webhook-section h4 {
    margin: 0 0 6px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .link-container {
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 10px;
    background: #f9f9f9;
    cursor: pointer;
    transition: all 0.2s;
  }

  .link-container:hover {
    background: #f0f0f0;
  }

  .link-with-copy {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .copy-icon {
    color: #666;
    font-size: 14px;
    flex-shrink: 0;
    transition: color 0.2s;
  }

  .copy-icon.copied {
    color: #339966;
  }

  .link-text {
    font-size: 14px;
    color: #333;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Watch Section */
  .watch-section {
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .watch-button {
    width: 100%;
    border: none;
    border-radius: 6px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
  }

  .watch-button.enable {
    background: #10b981;
    color: white;
  }

  .watch-button.enable:hover:not(:disabled) {
    background: #059669;
  }

  .watch-button.disable {
    background: #ef4444;
    color: white;
  }

  .watch-button.disable:hover:not(:disabled) {
    background: #dc2626;
  }

  .watch-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .watch-status {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
    text-align: center;
  }

  .watch-status.success {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
  }

  .watch-status.error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #ef4444;
  }

  .watch-status.info {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #3b82f6;
  }

  /* Instructions Section */
  .instructions-section {
    padding: 12px;
    background: #f0f9ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    height: 190px;
    overflow: auto;
  }

  .instructions-section h5 {
    margin: 0 0 12px 0;
    color: #1e40af;
    font-size: 13px;
    font-weight: 600;
  }

  /* Accordion Styles */
  .accordion {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .accordion-item {
    background: #ffffff;
    border: 1px solid #e0e7ff;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.2s;
  }

  .accordion-item:hover {
    border-color: #3b82f6;
  }

  .accordion-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    cursor: pointer;
    background: #f8fafc;
    transition: background 0.2s;
    user-select: none;
  }

  .accordion-header:hover {
    background: #eff6ff;
  }

  .step-number {
    font-weight: 700;
    color: #1e40af;
    min-width: 20px;
    font-size: 13px;
  }

  .step-title {
    flex: 1;
    font-weight: 600;
    color: #1e3a8a;
    font-size: 13px;
  }

  .arrow {
    color: #64748b;
    font-size: 10px;
    transition: transform 0.2s;
    transform: rotate(-90deg);
  }

  .arrow.expanded {
    transform: rotate(0deg);
  }

  .accordion-content {
    padding: 12px 16px 12px 40px;
    background: #ffffff;
    animation: slideDown 0.2s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 500px;
    }
  }

  .accordion-content ul {
    margin: 0;
    padding-left: 18px;
    font-size: 13px;
    line-height: 1.6;
    color: #475569;
  }

  .accordion-content li {
    margin-bottom: 6px;
  }

  .accordion-content code {
    background: #e0e7ff;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    color: #3730a3;
  }

  .steps-list {
    margin: 0;
    padding-left: 18px;
    font-size: 13px;
    line-height: 1.5;
    color: #1e3a8a;
  }

  .steps-list li {
    margin-bottom: 6px;
  }

  .steps-list code {
    background: #e0e7ff;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  }

  .external-link {
    color: #007bff;
    text-decoration: none;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: color 0.2s;
  }

  .external-link:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  /* Watch Info */
  .watch-info {
    margin: 15px 0 0 0;
    padding: 12px;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    border-radius: 6px;
  }

  .watch-info ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }

  .watch-info li {
    margin-bottom: 4px;
    font-size: 12px;
    color: #047857;
  }

  .watch-info strong {
    font-weight: 600;
  }

  .watch-info .status-enabled {
    color: #10b981;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;